<template>
    <div class="row m-3" v-if="applicantData">
      <div class="p-3 col-12 card card-with-shadow border-0">
        <img :src="applicantData.applicant.company.logo" alt="LOGO" class="width-150 mb-5" style="margin: auto">

        <div class="row">
          <div class="col-6" >
            <h4>Employment Verification Request for {{applicantData && applicantData.applicant.full_name}}</h4>
            <p>Dear {{applicantData && applicantData.statusable.contact_name}},</p>

            <p>I hope this message finds you well.</p>

            <p>We are currently conducting an employment verification for <strong>{{applicantData && applicantData.applicant.full_name}}</strong>, who has applied for a position with our company. As part of our standard hiring process, we kindly request your assistance in verifying the details of their previous employment with your organization.</p>

            <div class="details">
                <p>Could you please confirm the following details?</p>
                <p><strong>1. Employment Period:</strong> Start Date- {{applicantData.statusable.start_date_formatted}} To End Date- {{applicantData.statusable.end_date_formatted}}</p>
                <!-- <p><strong>2. Job Title:</strong> {{applicantData.statusable.start_date}}</p> -->
                <p><strong>3. Primary Responsibilities:</strong> {{applicantData.statusable.description}}</p>
                <p><strong>4. Reason for Leaving:</strong> {{applicantData.statusable.reason_for_leaving}}</p>

            </div>

            <div class="status_details">
                <p>Screening office remarks:</p>

              <div v-html="applicantData.action_comment">

              </div>
            </div>
          </div>
          <div class="col-6">
              <!-- <img src="/images/logo.png" alt="LOGO" class="width-300 mb-5" style="margin: auto"> -->
              <app-overlay-loader v-if="preloader" />
              <form
                  class="mb-0"
                  :class="{ 'loading-opacity': preloader }"
                  ref="form"
                  :data-url="addurl"
              >
                  <div class="row">
                      <div class="col-md-6 form-group align-items-center">
                          <label for="inputs_signed_by">
                              {{ $t("signed_by") }}
                          </label>
                          <app-input
                              id="inputs_signed_by"
                              type="text"
                              v-model="inputs.signed_by"
                              placeholder="Enter Name"
                              :required="true"
                          />
                      </div>
                      <div class="col-md-6 form-group align-items-center">
                          <label for="inputs_designation">
                          {{ $t("designation") }}
                          </label>
                          <app-input
                          id="inputs_designation"
                          type="text"
                          v-model="inputs.designation"
                          placeholder="Enter Designation"
                          />
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-12 form-group align-items-center">
                          <label for="inputs_endorsement_remarks">
                          {{ $t("endorsement_remarks") }}
                          </label>
                          <app-input
                          id="inputs_endorsement_remarks"
                          type="textarea"
                          placeholder="Enter Remarks"
                          v-model="inputs.endorsement_remarks"
                          />
                      </div>
                  </div>
                  <div class="row"> 
                    <div class="col-md-6 form-group align-items-center">
                          <label for="inputs_endorsed_at">
                              {{ $t("endorsed_at") }}
                          </label>
                          <app-input
                              id="inputs_endorsed_at"
                              type="date"
                              v-model="inputs.endorsed_at"
                              :required="true"
                          />
                      </div>
                  </div>
                  <div class="row" v-if="!inputs.signature">
                      <div class="col-md-12 form-group align-items-center">
                          <label for="inputs_signed_by">
                          {{ $t("signature") }}
                          </label>

                          <VueSignaturePad
                          id="signature"
                          width="100%"
                          height="200px"
                          ref="signaturePad"
                          :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                          />
                          <div class="mt-2 d-flex  justify-content-end align-items-center" >
                          <button @click.prevent="undo" class="btn btn-danger mr-2" >Undo</button>
                          </div>
                      </div>
                    <div class="action-buttons">
                      <button
                          type="submit"
                          class="btn btn-primary mr-2"
                          @click.prevent="submitForm"
                      >
                        {{ $t("submit") }}
                      </button>
                    </div>
                  </div>
                <div class="row" v-if="inputs.signature">
                  <div class="col-md-12 form-group align-items-center">
                          <label for="inputs_signed_by">
                          {{ $t("signature") }}
                          </label>
                        <img :src="inputs.signature" alt="" width="300">

                      </div>
                  </div>
              </form>

          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
import {FormMixin} from '../../../../core/mixins/form/FormMixin.js';
import {SCREENING_ENDORSEMENT_UPDATE, SCREENING_ENDORSEMENT_DETAIL} from "../../../Config/ScreeningAppUrl.js";
import { axiosGet } from "@/app/Helpers/AxiosHelper";

  export default {
    name: "ScreeningEndorsement",
    mixins: [FormMixin],
    data() {
      return {
        signaturePath: '',
        inputs: {
          endorsed_at: new Date(),
        },
        preloader: false,
        companyInfo: {},
        screeningEndorsementId: null,
        addurl: SCREENING_ENDORSEMENT_UPDATE,
        applicantData: null,
        endorsement: {},
        isAdmin: false
      };
    },
    created() {
      this.companyInfo = this.$attrs['companyData-prop'];
      this.endorsement = this.$attrs['endorsement-prop'];
      this.screeningEndorsementId = this.$attrs['screeningendorsementid'];
      this.isAdmin = this.$attrs['isadmin'];
      this.getScreeningEndorsementDetail(this.screeningEndorsementId);
      this.setEndorsement();

    },

    methods: {
      submitForm() {
        if(this.isAdmin){
          this.$toastr.e("You are not authorized.");
          return false;
        }
        const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
        if (data != null) {
          this.inputs.signature = data;
          this.inputs.screeningEndorsementId = this.screeningEndorsementId;

          let formData = new FormData();
          Object.keys(this.inputs).forEach((key) => {
            formData.append(key, this.inputs[key]);
          });
          this.save(formData)
        } else {
          this.$toastr.e("Signature is required.");
        }
      },
      beforeSubmit() {
        this.preloader = true;
      },
      afterSuccess(response) {
        this.preloader = false;
        this.$toastr.s(response.data.message);
        this.inputs = {};
        this.undo();
        setTimeout(() => {
          window.close();
        }, 3000);
        this.$toastr.i("Closing window in 3 secs.");

      },
      afterFinalResponse() {
        this.preloader = false;
      },
      afterError(response) {
        console.error("Error caught", response);
        // this.$toastr.e(response.response.data.message);
        this.preloader = false;
      },
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      getScreeningEndorsementDetail(screeningEndorsementId) {
        axiosGet(SCREENING_ENDORSEMENT_DETAIL + screeningEndorsementId)
            .then((res) => {
              this.applicantData = res.data;
            })
            .catch((error) => {

            });
      },
      setEndorsement() {

        if (this.isAdmin) {

          this.inputs = this.endorsement


        }
      },
    },




  };
</script>